<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="card">
    <div class="card-header pb-1">
      <h6 class="mb-0">{{name}}</h6>
      <!--With block subtitle-->
    </div>
    <img @click="open" class="card-img-top img-fluid pb-3" v-bind:src="getApiUrl()" alt="">
    <modal-default disableclose="true" buttontext="Close" v-bind:title="name" ref="thisModal" v-bind:onsave="doClose" size="modal-lg mx-4 mx-md-auto">
      <div style="max-height:calc(100vh - 270px);overflow-y:auto">
        <div class="container-fluid pb-3">
          <div class="card" style="width:100%">
            <img class="card-img-top img-fluid pb-3" v-bind:src="getApiUrl()" alt="">
          </div>
        </div>
      </div>
    </modal-default>
  </div>
</template>

<script>

  export default {
    name: "report-diagram-view",
    components: {

    },
    props: {
      reportid: {
        type: Number,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
      };
    },
    methods: {
      getApiUrl() {
        return apiUrl + '/api/Diagrams/v1/Diagram?hideTitle=true&reportid=' + this.reportid + '&diagramname=' + this.name + '&ticks=' + (new Date()).getTime();
      },
      open() {
        this.$refs.thisModal.open();
      },
      doClose() {
        this.$refs.thisModal.close();
      },
      getId() {
        return this._uid;
      },

    },
    watch: {
    },
    mounted() {

    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/report/report-diagram-view.vue